/* eslint-disable react/forbid-dom-props */
import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Dropdown.scss';
import DropdownItem from './DropdownItem';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
const PORTAL_MENU_Z_INDEX = 9999;
const FIXED_MENU_Z_INDEX = 1000;
const DropdownMenu = ({ _ref, actions, data, dropup = false, footerRenderer, hasLargeWidth, iconClassName, isStrikeAction, menuContainerStyle, menuContainerClassName, isRenderedInPortal = false, dataCy, selectedId, onClose, }) => {
    const { direction, isLayoutRTL } = useLayoutDirection();
    const menu = (<ul ref={_ref} className={classnames('dropdown-menu', styles.fixed, menuContainerClassName, {
        dropup,
        [styles.largeWidth]: hasLargeWidth,
    })} data-cy={dataCy ? `${dataCy}-menu` : undefined} data-layout-direction={direction} dir={direction} style={{
        ...menuContainerStyle,
        textAlign: isLayoutRTL ? 'right' : 'left',
        display: 'block',
        zIndex: isRenderedInPortal ? PORTAL_MENU_Z_INDEX : FIXED_MENU_Z_INDEX,
    }}>
      {actions.map(({ label, icon, iconSrc, iconType, onClick, hasStrike, disabled, itemWrapperClassName, item, hoverTitle, isCLoseOnClick, isPreventDefault, linkClassName, dataCy: actionDataCy, }, index) => icon || label ? (<DropdownItem key={label} className={itemWrapperClassName} data={data} dataCy={actionDataCy || (dataCy ? `${dataCy}-item` : undefined)} disabled={disabled} hasStrike={hasStrike} hoverTitle={hoverTitle} icon={icon} iconClassName={iconClassName} iconSrc={iconSrc} iconType={iconType} id={index} isCLoseOnClick={isCLoseOnClick} isPreventDefault={isPreventDefault} isSelected={selectedId === index} isStrikeAction={isStrikeAction} item={item} label={label} linkClassName={linkClassName} onClick={onClick} onClose={onClose}/>) : (<></>))}
      {footerRenderer && footerRenderer()}
    </ul>);
    if (isRenderedInPortal && typeof document !== 'undefined') {
        return ReactDOM.createPortal(menu, document.body);
    }
    return menu;
};
export default DropdownMenu;
